<template>
    <div class="v2_info-popup__body">
      <p>Assess specialty benchmarking data to shape the terms of a proposed job opportunity. </p>
      <ul class="list-style-disc pl-3">
        <li>
          Review data for any measure such as total compensation, wRVUs, or years of practice.
        </li>
        <li>
          Apply Filters to selected Measures to create personalized reports.
        </li>
        <li>
          For example, explore compensation ranges for specific locations and/or practice types. 
        </li>
        <li>
          Inform displays the 25th, 75th, and median figures for any selected cohort.
        </li>
      </ul>
      <p>Inform is available for any specialty in which you have purchased and posted a job opportunity. </p>
      <!-- <div class="pt-4">
        <b-tabs
          v-model="tabIndex"
          nav-class="justify-content-end v2_phairify-tabs mb-4"
          active-nav-item-class="font-weight-bold text-uppercase text-danger"
          active-tab-class="font-weight-bold text-success"
        >
          <b-tab
            :title-link-class="[
              'phairify-tab',
              { 'phairify-tab-active': tabIndex === 0 },
            ]"
          >
            <div
              slot="title"
              :class="['px-lg-5', 'px-3', 'py-2']"
              v-b-tooltip.hover
              title="Select to see information about Report measures"
            >
              Measures
            </div>
            <b-card-text>
              <p>To view data for a Measure:</p>
              <ol>
                <li>Click ‘Select Measures.’</li>
                <li>
                  Check the box(es) for any desired Measure(s) and click ‘Done.’
                </li>
              </ol>
            </b-card-text>
          </b-tab>
          <b-tab
            :title-link-class="[
              'phairify-tab',
              { 'phairify-tab-active': tabIndex === 1 },
            ]"
          >
            <div
              slot="title"
              :class="['px-lg-5', 'px-3', 'py-2']"
              v-b-tooltip.hover
              title="Select to see information about Report filters"
            >
              Filters
            </div>
            <b-card-text>
              <p>To apply a Filter to a Measure:</p>
              <ol>
                <li>
                  Expand the ‘Profile’ or ‘Core Questions’ menus under ‘Select
                  Filters.’
                </li>
                <li>
                  Check the box(es) or use the sliders for any Filter(s) you wish
                  to apply to the Measure.
                </li>
                <li>
                  Click ‘Apply’ in the Filters window to view the personalized
                  cohort.
                </li>
              </ol>
            </b-card-text>
          </b-tab>
          <b-tab
            active
            :title-link-class="[
              'phairify-tab',
              { 'phairify-tab-active': tabIndex === 2 },
            ]"
          >
            <div
              slot="title"
              :class="['px-lg-5', 'px-3', 'py-2']"
              v-b-tooltip.hover
              title="Select to see information about Reports"
            >
              Reports
            </div>
            <b-card-text>
              <p>From Reports, you can:</p>
              <ol>
                <li>Create a NEW report or SELECT a saved report</li>
                <li>
                  Select the DATA SOURCE you would like to query for your report
                </li>
                <li>Select the MEASURE(S) you would like to review</li>
                <li>
                  Select FILTER(S) to fine tune the data displayed for your
                  selected Measure(s)
                </li>
              </ol>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </div> -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'FiltersInfoPopup',
    data: function () {
      return {
        tabIndex: 0,
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .v2_info-popup__body {
    ul {
      list-style-type: none;
      padding: 0;
    }
  }
  </style>
  